var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pdf-wrapper",staticStyle:{"overflow-x":"hidden","overflow-y":"hidden","height":"100vh"}},[_c('iframe',{attrs:{"width":"100%","height":"100%","src":this.url,"allowfullscreen":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }